export enum USER_FEED {
    /** https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=425067827 */
    YOUR_FEED_IS_EMPTY = 'USER_FEED.YOUR_FEED_IS_EMPTY',
    /** https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=425067914 */
    NEW_PUBLICATIONS_FROM_SUBSCRIPTIONS_WILL_BE_LISTED_HERE = 'USER_FEED.NEW_PUBLICATIONS_FROM_SUBSCRIPTIONS_WILL_BE_LISTED_HERE',
}
